import axios from "axios";
import { logout } from "../lib/auth";
import { paymentConfirmTableColumn } from "../config/paymentConfirm";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

//  明細一覧取得
export async function getPaymentConfirmExcelRecords(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "paymentConfirmExcelRecords";
    const params = makeParams(paymentConfirmTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const paymentConfirmExcelRecords: dataDifine[] = response.data.fetch_data;
    const paymentConfirmExcelSumRecords: dataDifine[] = response.data.sum_data;
    const countPaymentConfirmExcelRecords: string = response.data.count_data;
    return {
      paymentConfirmExcelRecords,
      paymentConfirmExcelSumRecords,
      countPaymentConfirmExcelRecords,
    };
  } catch (error) {
    // logout();
  }
}

// 明細確定 - パートナー支払明細
export async function postPaymentConfirmExcelRecords(props: {
  sale_company_id: number | null;
  payment_year: string;
  payment_month: string;
  confirm_destination_key: string;
  sale_company_name: string;
  saleCompanyUniquePayments: {
    id: string;
    sale_company_unique_payment_name: string;
    sale_company_unique_payment_value: string;
  }[];
}) {
  try {
    const path = "paymentConfirmExcelRecords";
    const bodys = props;
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 明細確定 - パートナー支払明細
export async function postHighRankPaymentConfirmExcelRecords(props: {
  payment_year: string;
  payment_month: string;
}) {
  try {
    const path = "paymentConfirmExcelRecords/highRankCompany";
    const bodys = props;
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 明細詳細取得
export async function getPaymentConfirmExcelRecord(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "paymentConfirmExcelRecord";
    const params = {
      id: props.id,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
  }
}
